import api from "../../api";
import {
  accessApiKey,
  createAccessApiKey,
  renewAccessApiKey,
  getMerchantSecretEndpoint,
  regenerateMerchantSecretEndpoint,
} from "../../api/apisUrl";
import {
  ACCESSAPI_FAILD,
  ACCESSAPI_LOADING,
  ACCESSAPI_SUCCESS,
  ACCESSAPI_REMOVE,
  MERCHANT_SECRET_LOADING,
  MERCHANT_SECRET_SUCCESS,
  MERCHANT_SECRET_FAILD,
} from "../types";

export const fetchAccessApiKey = (token: string, id: string | number) => {
  return async (dispatch: (arg0: any) => void) => {
    dispatch({ type: ACCESSAPI_LOADING, loading: true });

    try {
      const res = await api.get(accessApiKey(id), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch({ type: ACCESSAPI_LOADING, loading: false });

      dispatch({
        type: ACCESSAPI_SUCCESS,
        status: res.status,
        payload: res.data,
      });
    } catch (err: any) {
      dispatch({ type: ACCESSAPI_LOADING, loading: false });

      if (err.response) {
        dispatch({
          type: ACCESSAPI_FAILD,
          status: err.response.status,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: ACCESSAPI_FAILD,
          error:
            "Something error !! Please contact the technical administrator.",
        });
      }
    }
  };
};

export const generateAccessApiKey = (token: any, userId: any, type: any) => {
  return async (dispatch: (arg0: any) => void) => {
    dispatch({ type: ACCESSAPI_LOADING, loading: true });

    try {
      const res = await api.post(
        createAccessApiKey(), // <-- /auth/api-key/generate
        {
          userId,
          type,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({ type: ACCESSAPI_LOADING, loading: false });

      dispatch({
        type: ACCESSAPI_SUCCESS,
        status: res.status,
        payload: res.data,
      });
    } catch (err: any) {
      dispatch({ type: ACCESSAPI_LOADING, loading: false });

      if (err.response) {
        dispatch({
          type: ACCESSAPI_FAILD,
          status: err.response.status,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: ACCESSAPI_FAILD,
          error:
            "Something error !! Please contact the technical administrator.",
        });
      }
    }
  };
};

export const renewAccessApiKeyAction = (
  token: any,
  userId: any,
  type: any = "merchant"
) => {
  return async (dispatch: (arg0: any) => void) => {
    dispatch({ type: ACCESSAPI_LOADING, loading: true });

    try {
      const res = await api.post(
        `${renewAccessApiKey()}?userId=${userId}&type=${type}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({ type: ACCESSAPI_LOADING, loading: false });

      dispatch({
        type: ACCESSAPI_SUCCESS,
        status: res.status,
        payload: res.data,
      });
    } catch (err: any) {
      dispatch({ type: ACCESSAPI_LOADING, loading: false });

      if (err.response) {
        dispatch({
          type: ACCESSAPI_FAILD,
          status: err.response.status,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: ACCESSAPI_FAILD,
          error:
            "Something error !! Please contact the technical administrator.",
        });
      }
    }
  };
};

// src/redux/actions/accessApi.ts

export const deleteAccessApiKey = (
  token: string,
  userId: string | number,
  type = "merchant"
) => {
  return async (dispatch: (arg0: any) => void) => {
    dispatch({ type: ACCESSAPI_LOADING, loading: true });

    try {
      const res = await api.delete(accessApiKey(userId), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          type,
        },
      });

      dispatch({ type: ACCESSAPI_LOADING, loading: false });

      dispatch({
        type: ACCESSAPI_SUCCESS,
        status: res.status,
        payload: null,
      });
    } catch (err: any) {
      dispatch({ type: ACCESSAPI_LOADING, loading: false });

      if (err.response) {
        dispatch({
          type: ACCESSAPI_FAILD,
          status: err.response.status,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: ACCESSAPI_FAILD,
          error:
            "Something error !! Please contact the technical administrator.",
        });
      }
    }
  };
};

export const revokeApiKey = (
  token: any,
  apiKeyId: any | number,
  type: any = "partner"
) => {
  return async (dispatch: (arg0: any) => void) => {
    dispatch({ type: ACCESSAPI_LOADING, loading: true });

    try {
      const res = await api.delete(`auth/api-key/${apiKeyId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          type,
        },
      });

      dispatch({ type: ACCESSAPI_LOADING, loading: false });

      dispatch({
        type: ACCESSAPI_SUCCESS,
        status: res.status,
        payload: null,
      });
    } catch (err: any) {
      dispatch({ type: ACCESSAPI_LOADING, loading: false });

      if (err.response) {
        dispatch({
          type: ACCESSAPI_FAILD,
          status: err.response.status,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: ACCESSAPI_FAILD,
          error:
            "Something error !! Please contact the technical administrator.",
        });
      }
    }
  };
};

export const ResetAccessApi = () => {
  return {
    type: ACCESSAPI_REMOVE,
  };
};

// Merchant Secret Actions
export const fetchMerchantSecret = (token: string, merchantId: string) => {
  return async (dispatch: (arg0: any) => void) => {
    dispatch({ type: MERCHANT_SECRET_LOADING, loading: true });

    try {
      const res = await api.get(getMerchantSecretEndpoint(merchantId), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch({ type: MERCHANT_SECRET_LOADING, loading: false });

      dispatch({
        type: MERCHANT_SECRET_SUCCESS,
        status: res.status,
        payload: res.data,
      });
    } catch (err: any) {
      dispatch({ type: MERCHANT_SECRET_LOADING, loading: false });

      if (err.response) {
        dispatch({
          type: MERCHANT_SECRET_FAILD,
          status: err.response.status,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: MERCHANT_SECRET_FAILD,
          error:
            "Something error !! Please contact the technical administrator.",
        });
      }
    }
  };
};

export const regenerateMerchantSecret = (token: string, merchantId: string) => {
  return async (dispatch: (arg0: any) => void) => {
    dispatch({ type: MERCHANT_SECRET_LOADING, loading: true });

    try {
      const res = await api.post(
        regenerateMerchantSecretEndpoint(merchantId),
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      dispatch({ type: MERCHANT_SECRET_LOADING, loading: false });

      dispatch({
        type: MERCHANT_SECRET_SUCCESS,
        status: res.status,
        payload: res.data,
      });
    } catch (err: any) {
      dispatch({ type: MERCHANT_SECRET_LOADING, loading: false });

      if (err.response) {
        dispatch({
          type: MERCHANT_SECRET_FAILD,
          status: err.response.status,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: MERCHANT_SECRET_FAILD,
          error:
            "Something error !! Please contact the technical administrator.",
        });
      }
    }
  };
};
